var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{on:{"click":_vm.startPrepareInvoicesJob}},[_vm._v("Start prepare invoices job")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }